var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "ma-0 pa-0", attrs: { fluid: "" } },
    [
      _c("Header", { attrs: { title: "New Thumbnail Test" } }),
      _c(
        "v-col",
        {
          staticClass: "pa-0",
          attrs: { id: "main_content_maxwidthset", cols: "12" },
        },
        [
          _c(
            "v-col",
            {
              staticClass: "ma-0 pa-5 mt-8 mb-7",
              attrs: { cols: "12", id: "cctv_player_box" },
            },
            [
              _c(
                "v-row",
                { staticClass: "ma-0 pa-0", attrs: { align: "center" } },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "ma-0 pa-2",
                      class: {
                        non_display:
                          _vm.streamingUrlList[0] == undefined ||
                          _vm.streamingUrlLoading,
                      },
                      attrs: { cols: "4", align: "center" },
                    },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "ma-0 pa-0",
                          staticStyle: { cursor: "pointer" },
                          attrs: { id: "thumbnail_box", cols: "12" },
                        },
                        [
                          _c("img", {
                            staticClass: "ma-0 pa-0",
                            staticStyle: { height: "100%", width: "100%" },
                            attrs: { id: "thumbnail_img0" },
                            on: {
                              load: function ($event) {
                                return _vm.onLoad(0)
                              },
                            },
                          }),
                          _vm.imgLoaders[0] == true
                            ? _c("v-skeleton-loader", {
                                attrs: {
                                  id: "img_skeleton",
                                  width: "100%",
                                  height: "13rem",
                                  boilerplate: false,
                                  elevation: "0",
                                  dark: "",
                                  type: "image",
                                },
                              })
                            : _vm._e(),
                          _vm.streamingUrlLoading == false
                            ? _c(
                                "v-col",
                                {
                                  staticClass: "ma-0 pa-0 pl-2",
                                  attrs: {
                                    cols: "12",
                                    id: "thumbnail_title_box",
                                    align: "left",
                                  },
                                },
                                [_vm._v(" " + _vm._s("国分寺店 外") + " ")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "ma-0 pa-2",
                      class: {
                        non_display:
                          _vm.streamingUrlList[1] == undefined ||
                          _vm.streamingUrlLoading,
                      },
                      attrs: { cols: "4", align: "center" },
                    },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "ma-0 pa-0",
                          staticStyle: { cursor: "pointer" },
                          attrs: { id: "thumbnail_box", cols: "12" },
                        },
                        [
                          _c("img", {
                            staticClass: "ma-0 pa-0",
                            staticStyle: { height: "100%", width: "100%" },
                            attrs: { id: "thumbnail_img1" },
                            on: {
                              load: function ($event) {
                                return _vm.onLoad(1)
                              },
                            },
                          }),
                          _vm.streamingUrlLoading == false
                            ? _c(
                                "v-col",
                                {
                                  staticClass: "ma-0 pa-0 pl-2",
                                  attrs: {
                                    cols: "12",
                                    id: "thumbnail_title_box",
                                    align: "left",
                                  },
                                },
                                [_vm._v(" " + _vm._s("国分寺店 外") + " ")]
                              )
                            : _vm._e(),
                          _vm.imgLoaders[1] == true
                            ? _c("v-skeleton-loader", {
                                attrs: {
                                  id: "img_skeleton",
                                  width: "100%",
                                  height: "13rem",
                                  boilerplate: false,
                                  elevation: "0",
                                  dark: "",
                                  type: "image",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "ma-0 pa-2",
                      class: {
                        non_display:
                          _vm.streamingUrlList[2] == undefined ||
                          _vm.streamingUrlLoading,
                      },
                      attrs: { cols: "4", align: "center" },
                    },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "ma-0 pa-0",
                          staticStyle: { cursor: "pointer" },
                          attrs: { id: "thumbnail_box", cols: "12" },
                        },
                        [
                          _c("img", {
                            staticClass: "ma-0 pa-0",
                            staticStyle: { height: "100%", width: "100%" },
                            attrs: { id: "thumbnail_img2" },
                            on: {
                              load: function ($event) {
                                return _vm.onLoad(2)
                              },
                            },
                          }),
                          _vm.streamingUrlLoading == false
                            ? _c(
                                "v-col",
                                {
                                  staticClass: "ma-0 pa-0 pl-2",
                                  attrs: {
                                    cols: "12",
                                    id: "thumbnail_title_box",
                                    align: "left",
                                  },
                                },
                                [_vm._v(" " + _vm._s("国分寺店 外") + " ")]
                              )
                            : _vm._e(),
                          _vm.imgLoaders[2] == true
                            ? _c("v-skeleton-loader", {
                                attrs: {
                                  id: "img_skeleton",
                                  width: "100%",
                                  height: "13rem",
                                  boilerplate: false,
                                  elevation: "0",
                                  dark: "",
                                  type: "image",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "ma-0 pa-2",
                      class: {
                        non_display:
                          _vm.streamingUrlList[3] == undefined ||
                          _vm.streamingUrlLoading,
                      },
                      attrs: { cols: "4", align: "center" },
                    },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "ma-0 pa-0",
                          staticStyle: { cursor: "pointer" },
                          attrs: { id: "thumbnail_box", cols: "12" },
                        },
                        [
                          _c("img", {
                            staticClass: "ma-0 pa-0",
                            staticStyle: { height: "100%", width: "100%" },
                            attrs: { id: "thumbnail_img3" },
                          }),
                          _vm.streamingUrlLoading == false
                            ? _c(
                                "v-col",
                                {
                                  staticClass: "ma-0 pa-0 pl-2",
                                  attrs: {
                                    cols: "12",
                                    id: "thumbnail_title_box",
                                    align: "left",
                                  },
                                },
                                [_vm._v(" " + _vm._s("国分寺店 外") + " ")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "ma-0 pa-2",
                      class: {
                        non_display:
                          _vm.streamingUrlList[4] == undefined ||
                          _vm.streamingUrlLoading,
                      },
                      attrs: { cols: "4", align: "center" },
                    },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "ma-0 pa-0",
                          staticStyle: { cursor: "pointer" },
                          attrs: { id: "thumbnail_box", cols: "12" },
                        },
                        [
                          _c("img", {
                            staticClass: "ma-0 pa-0",
                            staticStyle: { height: "100%", width: "100%" },
                            attrs: { id: "thumbnail_img4" },
                          }),
                          _vm.streamingUrlLoading == false
                            ? _c(
                                "v-col",
                                {
                                  staticClass: "ma-0 pa-0 pl-2",
                                  attrs: {
                                    cols: "12",
                                    id: "thumbnail_title_box",
                                    align: "left",
                                  },
                                },
                                [_vm._v(" " + _vm._s("国分寺店 外") + " ")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "ma-0 pa-2",
                      class: {
                        non_display:
                          _vm.streamingUrlList[5] == undefined ||
                          _vm.streamingUrlLoading,
                      },
                      attrs: { cols: "4", align: "center" },
                    },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "ma-0 pa-0",
                          staticStyle: { cursor: "pointer" },
                          attrs: { id: "thumbnail_box", cols: "12" },
                        },
                        [
                          _c("img", {
                            staticClass: "ma-0 pa-0",
                            staticStyle: { height: "100%", width: "100%" },
                            attrs: { id: "thumbnail_img5" },
                          }),
                          _vm.streamingUrlLoading == false
                            ? _c(
                                "v-col",
                                {
                                  staticClass: "ma-0 pa-0 pl-2",
                                  attrs: {
                                    cols: "12",
                                    id: "thumbnail_title_box",
                                    align: "left",
                                  },
                                },
                                [_vm._v(" " + _vm._s("国分寺店 外") + " ")]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.streamingUrlLoading
                ? [
                    _c("ImageSkeleton", {
                      attrs: { loaderCount: 9, width: "100%", height: "10rem" },
                    }),
                  ]
                : _vm._e(),
              _c(
                "v-row",
                {
                  staticClass: "ma-0 pa-0",
                  staticStyle: { display: "none" },
                  attrs: { align: "center" },
                },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "ma-0 pa-2",
                      attrs: { cols: "4", align: "center" },
                    },
                    [
                      _c("video", {
                        ref: "dash-video" + 0,
                        staticClass: "video-js",
                        staticStyle: { display: "none" },
                        attrs: { width: "300", height: "250" },
                      }),
                    ]
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "ma-0 pa-2",
                      attrs: { cols: "4", align: "center" },
                    },
                    [
                      _c("video", {
                        ref: "dash-video" + 1,
                        staticClass: "video-js",
                        staticStyle: { display: "none" },
                        attrs: { width: "300", height: "250" },
                      }),
                    ]
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "ma-0 pa-2",
                      attrs: { cols: "4", align: "center" },
                    },
                    [
                      _c("video", {
                        ref: "dash-video" + 2,
                        staticClass: "video-js",
                        staticStyle: { display: "none" },
                        attrs: { width: "300", height: "250" },
                      }),
                    ]
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "ma-0 pa-2",
                      attrs: { cols: "4", align: "center" },
                    },
                    [
                      _c("video", {
                        ref: "dash-video" + 3,
                        staticClass: "video-js",
                        staticStyle: { display: "none" },
                        attrs: { width: "300", height: "250" },
                      }),
                    ]
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "ma-0 pa-2",
                      attrs: { cols: "4", align: "center" },
                    },
                    [
                      _c("video", {
                        ref: "dash-video" + 4,
                        staticClass: "video-js",
                        staticStyle: { display: "none" },
                        attrs: { width: "300", height: "250" },
                      }),
                    ]
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "ma-0 pa-2",
                      attrs: { cols: "4", align: "center" },
                    },
                    [
                      _c("video", {
                        ref: "dash-video" + 5,
                        staticClass: "video-js",
                        staticStyle: { display: "none" },
                        attrs: { width: "300", height: "250" },
                      }),
                    ]
                  ),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }